/** Toggle only this page; selections on other pages belong to the user. */
export function togglePageSelection(selection: readonly string[], pageIds: readonly string[]): string[] {
  const next = new Set(selection);
  const remove = pageIds.length > 0 && pageIds.every((id) => next.has(id));
  for (const id of pageIds) {
    if (remove) next.delete(id);
    else next.add(id);
  }
  return [...next];
}
